import type { ListItemTextProps } from '@mui/material';
import { ListItemText as BaseListItemText } from '@mui/material';
import type { ElementType } from 'react';
import { font, nonOverflowText } from '../styles';

export function ListItemText<
  PrimaryTypographyComponent extends ElementType = 'span',
  SecondaryTypographyComponent extends ElementType = 'p',
>(props: ListItemTextProps<PrimaryTypographyComponent, SecondaryTypographyComponent>) {
  const { sx, ...restProps } = props;

  return (
    <BaseListItemText
      disableTypography
      sx={{
        ...font,
        ...nonOverflowText,
        ...sx,
      }}
      {...restProps}
    />
  );
}
